// TODO move this to a hook and use it everywhere it's needed
export const isValidEmail = ({config, email}) => {
  const emailRegex = config.get('REGEX_EMAIL')
  const regExpEmailValidation = new RegExp(emailRegex)

  return regExpEmailValidation.test(email)
}
